/* eslint-disable no-param-reassign */
import { Router } from 'express'
import { Services } from '../../../../types/Services'
import BookmarkController from './controller'
import listRoutes from './list/routes'

export function routes({ layoutPath, services }: { layoutPath: string; services: Services }): Router {
  const router = Router({ mergeParams: true })

  const controller = new BookmarkController(layoutPath, services)
  router.post('/', controller.POST)
  router.use(`/list`, listRoutes({ layoutPath, services }))
  return router
}

export default routes
